import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { Notifications } from '../../components/common';
import { isModalShown } from '../../components/common/modal-message/modal-message.selectors';
import {
  NotificationModel,
  NotificationPlacement,
} from '../../components/common/notifications/notifications.types';
import {
  removeNotification,
  showNotification,
} from '../../redux/actions/notifications';
import { StoreState } from '../../redux/reducers/store.types';
import { getNotifications } from '../../selectors/notifications/notifications';

interface Props {
  notifications: NotificationModel[];
  removeNotification(): void;
  showNotification(NotificationModel): void;
  isModalShown: boolean;
  placement: NotificationPlacement;
}

class NotificationsComponent extends React.Component<Props> {
  public onNotificationReady(notification: NotificationModel): void {
    this.props.showNotification(notification);
  }

  public getNotifications(): NotificationModel[] {
    const { notifications, placement }: Props = this.props;

    return _.filter(
      notifications,
      (notification: NotificationModel) => placement === notification.placement,
    );
  }

  public render() {
    const { removeNotification } = this.props;

    return (
      <Notifications
        notifications={this.getNotifications()}
        onNotificationClose={removeNotification}
        onReady={this.onNotificationReady.bind(this)}
      />
    );
  }
}

export const NotificationsContainer = connect<any, any, any>(
  (state: StoreState) => ({
    notifications: getNotifications(state),
    isModalShown: isModalShown(state),
  }),
  {
    removeNotification,
    showNotification,
  },
)(NotificationsComponent);
